export default "__VITE_ASSET__LvMjpToW__"